export default {
    data() {
        return {

        };
    },
    methods: {
        detatchLastKey(keychain, log) {
            var lastkey;
            var remainingkeys;
            var returnValue;
            if (keychain.includes(".")) {
                var lastkeyindex = keychain.lastIndexOf('.');           //find last key starting position
                lastkey = keychain.substring(lastkeyindex);             //get last key
                remainingkeys = keychain.replace(lastkey, "");          //remove last key from chain
                lastkey = lastkey.substring(1);                         //remove "." from lastkey
                returnValue = { remainingkeys, lastkey };
            }
            else {
                returnValue = { lastkey };
            }

            if (log) {
                console.log("keychain:" + keychain)
                console.log("lastkey:" + lastkey)
                console.log("remainingkeys:" + remainingkeys)
            }

            return returnValue;
        },

        getValueFromKeychain(inobject, keychain, log) {
            const keys = keychain.split(".");

            var returnValue = keys.reduce(function (reducedObject, potentialKey) {
                const keyValue = reducedObject ? reducedObject[potentialKey] : undefined;
                return keyValue;
            }, inobject || self);

            if (log) {
                console.log('[KeyDiver]');
                console.log('o: ', inobject);
                console.log('k: ' + keychain);
                console.log('r: ', returnValue);
                console.log('[/KeyDiver]');
            }

            return returnValue;
        },

        getValueFromKeychainNotLastKey(object, key, log) {
            if (log) {
//                console.log('[KeyDiver]');
            }

            if (key.includes(".")) {
                var separatedLastKeyFromChain = this.detatchLastKey(key, log);
                object = this.getValueFromKeychain(object, separatedLastKeyFromChain.remainingkeys, false)
                key = separatedLastKeyFromChain.lastkey
            }

            if (log) {
//                console.log('o: ', object);
//                console.log('k: ' + key);
//                console.log('[/KeyDiver]');
            }

            return { object, key }
        },
    }
}